import {Component} from '@angular/core';
import {DataStorageService} from '../../../../data-storage.service';
import {ContactPerson} from '../../../../../models/contactPerson';
import {ApiCustomerService} from '../../../../apiServices/customer/api-customer.service';

@Component({
  selector: 'app-new-contact-person',
  templateUrl: './new-contact-person.component.html',
  styleUrls: ['./new-contact-person.component.scss']
})
export class NewContactPersonComponent {

  allowUpdate: boolean;

  constructor(public dataStorageService: DataStorageService,
              private api: ApiCustomerService) {
    this.allowUpdate = dataStorageService.currentState.offerID !== 0;
  }

  addNewContactClick() {
    const newContactPerson: ContactPerson = new ContactPerson();
    this.dataStorageService.currentState.customerProfile.contacts.push(newContactPerson);
  }

  removeContactClick(i: number) {
    if (this.dataStorageService.editMode) {
      this.dataStorageService.currentState.customerProfile.contacts.splice(i, 1);
    }
    this.api.putCustomer();
  }

  /**
   * @param i       position in array
   * @param event   event from HTML
   * @param field   name of field in CustomerProfile
   */
  setContactValue(i: number, event: any, field: string) {
    this.dataStorageService.currentState.customerProfile.contacts[i][field] = event.target.value;
    this.api.putCustomer();
  }

  updateCustomer() {
    this.api.putCustomer();
  }

}



// WEBPACK FOOTER //
// ./src/app/content/new-offer/customer-profile/new-contact-person/new-contact-person.component.ts